export var AttachmentStatus;
(function (AttachmentStatus) {
    AttachmentStatus[AttachmentStatus["FAILED"] = 1] = "FAILED";
    AttachmentStatus[AttachmentStatus["INVALID_EXTENSION"] = 2] = "INVALID_EXTENSION";
    AttachmentStatus[AttachmentStatus["MAX_FILE_SIZE_EXCEEDED"] = 3] = "MAX_FILE_SIZE_EXCEEDED";
    AttachmentStatus[AttachmentStatus["OK"] = 200] = "OK";
})(AttachmentStatus || (AttachmentStatus = {}));
export var AttachmentType;
(function (AttachmentType) {
    AttachmentType[AttachmentType["IMAGE"] = 1] = "IMAGE";
    AttachmentType[AttachmentType["VIDEO"] = 2] = "VIDEO";
    AttachmentType[AttachmentType["AUDIO"] = 3] = "AUDIO";
})(AttachmentType || (AttachmentType = {}));
;
//# sourceMappingURL=attachment.i.js.map